const MEMBERSHIP_CATEGORY = {
  1: {
    name: 'Standard',
    color: '#FFFFFF',
    number: undefined
  },
  2: {
    name: 'Pro',
    color: '#979797'
  },
  3: {
    name: 'Bronze',
    color: '#B48203',
    description: 'Voice123 membership plans allow top professionals who want to invest in their career to boost their performance.'
  },
  4: {
    name: 'Premium',
    color: '#1E88E5',
    number: 1,
    description: 'Voice123 membership plans allow top professionals who want to invest in their career to boost their performance.'
  },
  5: {
    name: 'Platinum',
    color: '#FEC100',
    number: 2,
    description: 'Voice123 membership plans allow top professionals who want to invest in their career to boost their performance.'
  },
  NA: {
    name: 'Standard',
    color: '#FFFFFF'
  }
};

export default {
  props: {
    type: { type: [ String, Number ] },
    isAi: { type: Boolean, default: false},
    size: { type: Number },
    showMembershipId: { type: Boolean, default: false },
    clickable: { type: Boolean, default: false }
  },

  data: function() {
    return {
      badgeInfo: {
        size: '24px',
        color: '#ffffff'
      }
    };
  },

  computed: {
    isVisible() {
      return this.isAi || this.type > 1 || typeof this.type === 'string' && this.type !== 'standard-1';
    }
  },

  watch: {
    type() {
      this.setColor();
    }
  },

  methods: {
    setColor() {
      let id = 1;

      if (typeof this.type === 'string') {
        if (this.type.includes('bronze')) {
          id = 3;
        } else if (this.type.includes('premium')) {
          id = 4;
        } else if (this.type.includes('platinum')) {
          id = 5;
        }
      } else if (this.type > 1) {
        id = this.type;
        if (this.type === 3) {
          id = 3;
        } else if (this.type >= 3 && this.type < 10) {
          id = 4;
        } else if (this.type >= 10) {
          id = 5;
        }
      }

      let membership = MEMBERSHIP_CATEGORY[ id || 'NA' ];

      this.badgeInfo = {
        size: this.size + 'px' || this.badgeInfo.size,
        color: this.isAi && '#424242' || membership && membership.color || this.badgeInfo.color,
        name: membership && membership.name,
        number: membership && membership.number || '',
        description: membership && membership.description || ''
      };
    },

    onBadgeClick(evt) {
      if (this.clickable && !this.isAi) {
        evt.preventDefault();

        this.$emit('click', {
          icon: {
            icon: 'badge',
            mdIcon: false,
            customIcon: true,
            style: { 'font-size': this.badgeInfo.size, color: this.badgeInfo.color }
          },
          title: this.badgeInfo.name,
          content: this.badgeInfo.description
        });
      }
    }
  },

  created() {
    this.setColor();
  }
};